export const InfoCircleIcon = ({ width, height, color, ...props }) => {
  return (
    <svg
      {...props}
      width={width || '16'}
      height={height || '16'}
      viewBox="0 0 16 16"
      fill="none"
      stroke={color || '#667085'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_info_circle_icon)">
        <path
          d="M7.99967 10.6654V7.9987M7.99967 5.33203H8.00634M14.6663 7.9987C14.6663 11.6806 11.6816 14.6654 7.99967 14.6654C4.31778 14.6654 1.33301 11.6806 1.33301 7.9987C1.33301 4.3168 4.31778 1.33203 7.99967 1.33203C11.6816 1.33203 14.6663 4.3168 14.6663 7.9987Z"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_info_circle_icon">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InfoCircleIcon;
